export default __webpack_public_path__ + "static/Graphik-Bold-Web-71e270778be6518cc8bd6ed3058a757c.eot";